<h2 mat-dialog-title>
  <span>{{ isEditMode ? "Edit" : "Add" }} Protection Type</span>
  <div class="subtitle">
    {{
      isEditMode
        ? "Edit the protection type details for this merchant."
        : "Add a new protection type to your system."
    }}
  </div>
</h2>

<mat-dialog-content [formGroup]="form">
  <div class="pv-xs" fxLayout="column" fxLayoutGap="8px">
    <mat-form-field appearance="outline">
      <mat-label>Protection Type</mat-label>
      <mat-select formControlName="type" placeholder="Select protection type">
        <mat-option *ngFor="let type of protectionTypes" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('type').hasError('required')">
        Protection type is required
      </mat-error>
    </mat-form-field>

    <div *ngIf="form.get('type').value" class="mb-md">
      <label class="fs-sm fw-semi-b mb-xs d-block">Linked Insurer(s)</label>
      <mat-radio-group
        formControlName="insurers"
        fxLayout="row wrap"
        fxLayoutGap="16px"
      >
        <mat-radio-button *ngFor="let insurer of insurers" [value]="insurer.id">
          {{ insurer.name }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-error
        *ngIf="form.get('insurers').invalid && form.get('insurers').touched"
        class="fs-xs mt-xs"
      >
        Linked insurer is required
      </mat-error>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Protection Title</mat-label>
      <textarea
        formControlName="title"
        matInput
        placeholder="Enter protection title"
        rows="5"
      ></textarea>
      <mat-error *ngIf="form.get('title').hasError('required')">
        Protection title is required
      </mat-error>
    </mat-form-field>

    <div class="email-input" fxLayout="column">
      <div class="fs-sm fw-semi-b mb-xs d-block">Email</div>
      <mat-form-field appearance="outline">
        <mat-label>To</mat-label>
        <mat-chip-list #toChipList>
          <mat-chip
            (removed)="removeEmail(i, 'to')"
            *ngFor="let email of toEmails.value; let i = index"
            [removable]="true"
          >
            {{ email }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            (matChipInputTokenEnd)="addEmail($event, 'to')"
            [matChipInputAddOnBlur]="true"
            [matChipInputFor]="toChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            placeholder="Add email here"
          />
        </mat-chip-list>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Cc</mat-label>
        <mat-chip-list #ccChipList>
          <mat-chip
            (removed)="removeEmail(i, 'cc')"
            *ngFor="let email of ccEmails.value; let i = index"
            [removable]="true"
          >
            {{ email }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            (matChipInputTokenEnd)="addEmail($event, 'cc')"
            [matChipInputAddOnBlur]="true"
            [matChipInputFor]="ccChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            placeholder="Add email here"
          />
        </mat-chip-list>
      </mat-form-field>
    </div>

    <div class="mb-md">
      <label class="fs-sm fw-semi-b mb-xs d-block"
        >Upload Protection Catalog</label
      >
      <app-resizable-upload
        [accept]="'.png,.jpg,.jpeg,.pdf'"
        [maxSize]="5"
        [requireCropping]="false"
        formControlName="catalog"
      ></app-resizable-upload>
      <mat-error
        *ngIf="
          form.get('catalog').hasError('required') &&
          (form.get('catalog').touched || form.get('catalog').dirty)
        "
        class="fs-xs mt-xs"
      >
        Catalog upload is required
      </mat-error>
      <mat-error
        *ngIf="
          form.get('catalog').hasError('fileSize') &&
          (form.get('catalog').touched || form.get('catalog').dirty)
        "
        class="fs-xs mt-xs"
      >
        File size must not exceed 5MB
      </mat-error>

      <div
        *ngIf="isEditMode && data.protection.catalog"
        class="pv-xs"
        fxLayout="column"
        fxLayoutGap="8px"
      >
        <app-document-card
          (toggleDelete)="toggleDeletion($event)"
          [document]="data.protection.catalog"
          [showViewButton]="false"
        ></app-document-card>
      </div>
    </div>

    <div class="mb-md">
      <label class="fs-sm fw-semi-b mb-xs d-block"
        >Protection Description</label
      >
      <div class="NgxEditor__Wrapper">
        <ngx-editor-menu
          [editor]="editor"
          [toolbar]="toolbar"
        ></ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          formControlName="description"
          placeholder="Type protection description here..."
        ></ngx-editor>
      </div>
      <mat-error
        *ngIf="
          form.get('description').invalid &&
          (form.get('description').touched || form.get('description').dirty)
        "
        class="fs-xs mt-xs"
      >
        Description is required
      </mat-error>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onCancel()" mat-button>Cancel</button>
  <button
    (click)="onSave()"
    [disabled]="form.invalid || (isEditMode && !isFormChanged)"
    color="primary"
    mat-raised-button
  >
    {{ isEditMode ? "Update" : "Add" }} Protection
  </button>
</mat-dialog-actions>
